import "can/map/";
import "toastr";
import _includes from 'lodash/includes';

const Refresh = new can.Map({
    viewModel: null,
    notification: true,
    interval: {
        value: 120000,
        type: "number"
    },
    intervalId: 0,

    refreshData(isSwitch) {
        "use strict";

        const vm = this.attr("viewModel");

        if (vm) {
            vm['%root'].attr('enableRefreshButton', true);
            vm['%root'].attr('loadingClassname', "loading");
            vm.refreshData(!isSwitch ? false : true);
        }
    },

    auto() {
        "use strict";

        const vm = this.attr("viewModel");

        // Clear the time interval if the value is zero
        if (this.attr("interval.value") === 0) {
            clearInterval(this.intervalId);
            return false;
        }

        if (vm) {
            clearInterval(this.intervalId);
            this.intervalId = setInterval(() => {
                vm.refreshData();
            }, this.attr("interval.value"));
        }

    },

    clear() {
        "use strict";

        this.attr("viewModel", null);
        clearInterval(this.intervalId);
    },

    autoOff() {
        "use strict";

        clearInterval(this.intervalId);
    }
});

export default Refresh;

// This will trigger when there is a changes on interval value
Refresh.bind("interval.value", () => {
    "use strict";

    if (Refresh.notification) {
        toastr.info(Locale.translate("System's auto refresh time interval was changed."));
    } else {
        Refresh.attr("notification", true);
    }

    Refresh.auto();
});
